import { useCallback, useEffect } from 'react';
import { queryKeys } from 'utils/react-query';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { useQueryClient } from 'react-query';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { useCurrentUserId } from 'modules/Auth/hooks';
import { IconPlus } from 'components/Icons';
import { cx } from '@linaria/core';

type Props = {
  className?: string;
};

export const AddNewCard: React.FC<Props> = ({ children, className }) => {
  const queryClient = useQueryClient();
  const userId = useCurrentUserId();
  const { track } = useDataCollection();

  useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      if (event.type === 'message' && event.data?.type === 'cardAdded') {
        cogoToast.success('Card added successfully');
        queryClient.invalidateQueries([queryKeys.UserCreditCards, { userId }]);

        track('Card Added Successfully');
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  const showModal = useCallback(() => {
    const newWindowWidth = 700;
    const newWindowHeight = 800;
    const screenWidth = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;
    const screenHeight = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;

    const left = (screenWidth - newWindowWidth) / 2;
    const top = (screenHeight - newWindowHeight) / 2;

    const auth_link = `/${userId}/card`;

    window.open(auth_link, 'pagename', `top=${top},left=${left},height=${newWindowHeight},width=${newWindowWidth},popup,menubar=no,resizable=no`);
    track('Add Credit Card Modal Opened');
  }, [userId]);

  return (
    <button
      type="button"
      className={cx(className)}
      onClick={showModal}
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          showModal();
        }
      }}
    >
      {children ?? (
        <div className="content">
          <IconPlus size={20} color="var(--Gray-400, #b0b7c3)" />
          <p className="card-brand-digit-info">Add a Credit Card</p>
        </div>
      )}
    </button>
  );
};
